import * as Yup from 'yup'

export const Required = Yup.string().required('Required')
export const Boolean = Yup.boolean().required('Required')
export const ArrayOfStrings = Yup.array().of(Yup.string()).min(1, 'Required')
